import "./style.scss";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import type { Swiper as SwiperClass } from "swiper/types";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import SubMenuSlideOne from "@/src/assets/Header/SubMenuSlideOne.png";
import SubMenuSlideTwo from "@/src/assets/Header/SubMenuSlideTwo.png";
import SubMenuSlideThree from "@/src/assets/Header/SubMenuSlideThree.png";
import { Link } from "react-router-dom";

interface HeaderDeskSubMenuSliderProps {
  handleLinkEvent: () => void;
}

const HeaderDeskSubMenuSlider = ({ handleLinkEvent }: HeaderDeskSubMenuSliderProps) => {
  const prevRef = useRef<HTMLButtonElement>(null);
  const nextRef = useRef<HTMLButtonElement>(null);

  return (
    <div className="news-slider">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={0}
        slidesPerView={1}
        loop={true}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        navigation={{
          prevEl: prevRef.current!,
          nextEl: nextRef.current!,
        }}
        pagination={{
          el: ".news-slider-pagination",
          clickable: true,
        }}
        onBeforeInit={(swiper: SwiperClass) => {
          if (typeof swiper.params.navigation !== "boolean" && swiper.params.navigation) {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
          }
        }}
      >
        <SwiperSlide className="news-slider-slide">
          <Link to="/single-page/admission-process-full-time" onClick={handleLinkEvent}>
            <div className="news-slider-background">
              <img src={SubMenuSlideOne} alt="Sub Menu Slider Img" />
            </div>
            <div className="news-slider-content">
              <div className="news-slider-content-title">дистанционная форма обучения</div>
              <div className="news-slider-content-description">
                Учись в удобное время — подбираем расписание под твои цели и возможности.
              </div>
            </div>
          </Link>
        </SwiperSlide>
        <SwiperSlide>
          <Link to="/single-page/admisision-process-distance-learning" onClick={handleLinkEvent}>
            <div className="news-slider-background">
              <img src={SubMenuSlideTwo} alt="Sub Menu Img" />
            </div>
            <div className="news-slider-content">
              <div className="news-slider-content-title">очная форма обучения</div>
              <div className="news-slider-content-description">
                Образование по стандартам ЕС — качество, признание диплома и актуальные программы.
              </div>
            </div>
          </Link>
        </SwiperSlide>
        <SwiperSlide>
          <Link to="/apply-online" onClick={handleLinkEvent}>
            <div className="news-slider-background">
              <img src={SubMenuSlideThree} alt="Sub Menu Img" />
            </div>
            <div className="news-slider-content">
              <div className="news-slider-content-title">Подавай заявку сейчас </div>
              <div className="news-slider-content-description">
                Успей поступить в этом году — оформи заявку онлайн и получи письмо о зачислении.
              </div>
            </div>
          </Link>
        </SwiperSlide>
        <div className="news-slider-pagination" />
      </Swiper>
    </div>
  );
};

export default HeaderDeskSubMenuSlider;
